import { Controller } from '@hotwired/stimulus'

// Suggests names from a <datalist> on the page in a dropdown under a text
// input. Drawn here rather than via the input's `list` attribute because
// Firefox shows no native datalist popup when form history is turned off.
export default class extends Controller {
  static targets = ['input', 'menu']
  static values = { source: String }

  show() {
    const query = this.inputTarget.value.trim().toLowerCase()
    const matches = this.names.filter((name) => name.toLowerCase().includes(query))
    this.active = -1

    if (matches.length === 0 || (matches.length === 1 && matches[0].toLowerCase() === query)) {
      this.hide()
      return
    }

    this.menuTarget.replaceChildren(...matches.map((name) => this.item(name)))
    this.menuTarget.classList.add('show')
  }

  hide() {
    this.menuTarget.classList.remove('show')
    this.active = -1
  }

  // Bound to mousedown, not click: cancelling it keeps focus in the input, so
  // the input's blur doesn't hide the menu before the pick lands.
  pick(event) {
    event.preventDefault()
    this.choose(event.currentTarget.textContent)
  }

  navigate(event) {
    if (!this.menuTarget.classList.contains('show')) return

    const items = Array.from(this.menuTarget.querySelectorAll('.dropdown-item'))
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault()
      const step = event.key === 'ArrowDown' ? 1 : -1
      if (this.active < 0) {
        this.active = step > 0 ? 0 : items.length - 1
      } else {
        this.active = (this.active + step + items.length) % items.length
      }
      items.forEach((item, index) => item.classList.toggle('active', index === this.active))
      items[this.active].scrollIntoView({ block: 'nearest' })
    } else if (event.key === 'Enter' && this.active >= 0) {
      event.preventDefault()
      this.choose(items[this.active].textContent)
    } else if (event.key === 'Escape') {
      // Close only the menu, not the modal the form sits in.
      event.preventDefault()
      event.stopPropagation()
      this.hide()
    }
  }

  choose(name) {
    this.inputTarget.value = name
    this.hide()
  }

  item(name) {
    const button = document.createElement('button')
    button.type = 'button'
    button.className = 'dropdown-item'
    button.textContent = name
    button.dataset.action = 'mousedown->name-suggest#pick'

    const li = document.createElement('li')
    li.append(button)
    return li
  }

  get names() {
    const list = document.getElementById(this.sourceValue)
    return list ? Array.from(list.options, (option) => option.value) : []
  }
}
